import * as React from 'react';
import { useSelector } from 'react-redux';

import { PageContainerWithData } from './PageContainerWithData';
import { selectFormData } from '../../selectors/selectFormData';

export function PageContainer() {
  const formData = useSelector(selectFormData);

  if (!formData) {
    /** TODO если нет данных - выбросить экран ошибки */
    return null;
  }

  return <PageContainerWithData formData={formData} />;
}
